import { useTranslation } from 'react-i18next'

import { MoneyIcon, ShoppingCartIcon } from '@phosphor-icons/react'

import { FormatNumber, FormatPrice } from '@reveni-io/reveni-ui'

import { statisticOrientations } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

import * as Styles from './styles'

const RefundMethodsTotals = ({
  totalRefunds,
  totalAmount,
  currency,
  orientation = statisticOrientations.horizontal,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Group orientation={orientation}>
      <Statistic
        size="small"
        isOutlined={false}
        Icon={ShoppingCartIcon}
        label={t('Total reembolsos')}
        value={<FormatNumber style="decimal">{totalRefunds}</FormatNumber>}
      />
      <Statistic
        size="small"
        isOutlined={false}
        Icon={MoneyIcon}
        label={t('Importe total')}
        value={<FormatPrice currency={currency}>{totalAmount}</FormatPrice>}
      />
    </Styles.Group>
  )
}

export default RefundMethodsTotals
